// extracted by mini-css-extract-plugin
export var dividerContainer = "_a0-0";
export var line = "_a0-1";